import { render, staticRenderFns } from "./DetaliiOfertaProductie.vue?vue&type=template&id=20b752b7&scoped=true"
import script from "./DetaliiOfertaProductie.vue?vue&type=script&lang=js"
export * from "./DetaliiOfertaProductie.vue?vue&type=script&lang=js"
import style0 from "./DetaliiOfertaProductie.vue?vue&type=style&index=0&id=20b752b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b752b7",
  null
  
)

export default component.exports